(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bastion-film"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-opening-film]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('video'), source = video.querySelector('source');
    const toggle = root.querySelector('[data-film-toggle]'), still = root.querySelector('[data-film-still]');
    const status = root.querySelector('[data-film-status]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const welcome = document.querySelector('[data-bkc-welcome]');
    const mp4 = source.src;
    let visible = true, manual = false, stopped = false, contextPause = false, completed = false, retried = false, timer;
    const quiet = () => reduced.matches || !!navigator.connection?.saveData;
    if (root.dataset.hls && video.canPlayType('application/vnd.apple.mpegurl')) {
      source.src = root.dataset.hls;
      source.type = 'application/vnd.apple.mpegurl';
    }
    const update = () => {
      toggle.textContent = completed ? toggle.dataset.replay : video.paused ? toggle.dataset.play : toggle.dataset.pause;
      toggle.setAttribute('aria-pressed', String(!video.paused));
    };
    const suspend = () => { clearTimeout(timer); if (!video.paused) { contextPause = true; video.pause(); } };
    const showStill = () => { video.hidden = true; still.hidden = false; };
    const failed = () => {
      clearTimeout(timer);
      if (!retried && source.src !== mp4) {
        retried = true; source.src = mp4; source.type = 'video/mp4'; video.load();
        if (!document.hidden && visible && !welcome?.open) play();
      } else {
        stopped = true; suspend(); showStill(); update();
        status.textContent = root.dataset.failed;
      }
    };
    const watch = () => { clearTimeout(timer); timer = setTimeout(() => { if (video.readyState < 2) failed(); }, 8000); };
    const play = () => {
      video.hidden = false; still.hidden = true;
      if (completed || video.ended) { video.currentTime = 0; completed = false; }
      watch();
      video.play()?.catch((error) => {
        if (error.name === 'NotAllowedError') { clearTimeout(timer); stopped = true; status.textContent = root.dataset.blocked; update(); }
        else if (error.name !== 'AbortError') failed();
      });
    };
    const sync = () => {
      if (welcome?.open && completed) { completed = false; stopped = false; video.currentTime = 0; }
      if (document.hidden || !visible || welcome?.open) { suspend(); return; }
      if (!stopped && !completed && (manual || !quiet())) play();
    };
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      manual = true; stopped = !video.paused;
      if (stopped) video.pause();
      else { if (video.error) video.load(); play(); }
    });
    video.addEventListener('play', () => { stopped = false; watch(); update(); });
    video.addEventListener('playing', () => { clearTimeout(timer); status.textContent = ''; update(); });
    video.addEventListener('pause', () => { clearTimeout(timer); if (contextPause) contextPause = false; else stopped = true; update(); });
    video.addEventListener('ended', () => { clearTimeout(timer); completed = true; stopped = true; showStill(); update(); });
    video.addEventListener('error', failed); source.addEventListener('error', failed);
    reduced.addEventListener('change', () => { if (reduced.matches) { stopped = true; suspend(); update(); } });
    document.addEventListener('visibilitychange', sync);
    if (welcome) new MutationObserver(sync).observe(welcome, { attributes:true, attributeFilter:['open'] });
    if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; sync(); }, { threshold:0.15 }).observe(root);
    window.addEventListener('pagehide', suspend);
    update(); sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var menu = document.querySelector('.bkc-header__menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.bkc-header__menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('focusin', function (event) {
    document.querySelectorAll('.bkc-header__menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
